import React, {useContext, Fragment} from 'react';
import {withRouter} from 'react-router-dom'
import Tour, {Navigation, Dot, Controls} from "reactour";
import {TourContext} from "../../contexts/TourContext";
import {disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks} from "body-scroll-lock";
import HeartAnimation from "../Hearts";
import HeartFilled from "../../assets/images/Happily-Ever-After-Icons-Heart-filled.png";
import Employee from "../../assets/images/casey_meygan.png";
import './tour.scss'
import {isMobile, isTablet} from 'react-device-detect';

const CTour = ({location: {pathname}, history}) => {
    const {state, dispatch} = useContext(TourContext);
    // console.log('pathname:', pathname);
    const closeTour = () => {
        dispatch({
            type: 'CLOSE',
        });
        clearAllBodyScrollLocks();
    };

    const pulseTitle = () => {
        dispatch({
            type: 'PULSE'
        })
    }

    const increase_step = (current_step) => {
        dispatch({
            type: 'NEXT_STEP'
        })
        if (current_step === 1) {
            return history.push('/section/Sex-and-Intimacy')
        }
        if (current_step === 7) {
            return history.push('/progress')
        }

    }

    const disableBody = target => disableBodyScroll(target);
    const enableBody = target => enableBodyScroll(target);

    const tourWatch = () => {
        let watchedHeart = document.querySelector('.watched');
        let image = watchedHeart.firstChild.firstChild;
        image.className = "heart-new is_animating is_favorite";
    }
    const tourReview = () => {

        let reviewedHeart = document.querySelector('.reviewed');
        let image = reviewedHeart.firstChild.firstChild;
        image.className = "heart-new is_animating is_favorite";
    }
    const tourLearn = () => {

        let learnedHeart = document.querySelector('.learned');
        let image = learnedHeart.firstChild.firstChild;
        image.className = "heart-new is_animating is_favorite";
    }


    const determinePosition = (stepNumber) => {
        if (isMobile) {
            switch (stepNumber) {
                case 1:
                    return [20, 10];
                case 2:
                    return [20, 300];
                default:
                    return 'top'
            }
        }

    }

    const steps = [
        {
            selector: '[data-tut="reactour__outer"]',
            content: `Let's start with progress. We have ordered these categories based on your assessment results. Start
                    with the category at the top and work your way down.`
            ,
            action: () => {

                if (state.pulseTitle)
                    return pulseTitle()
            },
            position: determinePosition(1)
        },
        {
            selector: '[data-tut="reactour__title"]',
            content: () => (
                <p>To watch a video, simply click the title!</p>

            ),
            action: () => {
                if (!state.pulseTitle)
                    return pulseTitle()
            },
            position: determinePosition(2),
        },
        {
            selector: '[data-tut="reactour__video"]',
            content: () => (
                <p>Here is where you can view the video. Once you have finished watching the video, we will fill in the
                    heart below.</p>
            ),
            action: () => {

            },
            position: determinePosition(3),
        },
        {
            selector: '[data-tut="reactour__watch"]',
            content: () => (
                <p>Just like that. Great job! Next, I'll show you how to review the connecting questions.</p>
            ),
            action: () => {
                tourWatch();
            },
            position: determinePosition(4),
        },
        {
            selector: '[data-tut="reactour__cq_button"]',
            content: () => (
                <p>Clicking this button will open the connecting questions associated with this video in another window.
                    Once you review the document...</p>
            ),
            action: () => {

            },
            position: determinePosition(5),
        },
        {
            selector: '[data-tut="reactour__review"]',
            content: () => (
                <p>You guessed it! We'll fill in the heart!</p>
            ),
            action: () => {
                tourReview();
            }
        },
        {
            selector: '[data-tut="reactour__learn"]',
            content: () => (
                <p>Once you've watched the video and reviewed the connecting questions, <strong>you will need to click
                    this heart to complete the section!</strong></p>
            ),
            action: () => {
                tourLearn();
            }
        },
        {
            selector: '[data-tut="reactour__blank"]',
            content: () => (
                <p>Lastly, let me show you what it will look like when you complete a section.</p>
            ),
            action: () => {

            },
            position: 'center'
        },
        {
            selector: isTablet ? '[data-tut="reactour__outer"]' : '[data-tut="reactour__title"]',
            content: () => (
                <Fragment>
                    <p>When you complete a section, all the hearts and the category icon will fill in. That's it! </p>
                    <button
                        style={{
                            border: "1px solid #e7be04",
                            backgroundColor: "#e7be04",
                            padding: ".3em .7em",
                            fontSize: "inherit",
                            display: "block",
                            cursor: "pointer",
                            margin: "1em auto",
                            color: "#fff"
                        }}
                        onClick={() => {
                            closeTour();
                        }
                        }
                    >
                        GET STARTED!
                    </button>
                </Fragment>

            ),
            action: () => {

                if (state.pulseTitle)
                    return pulseTitle()
            }
        },
    ];


    function MyCustomHelper({current, content, totalSteps, gotoStep, close}) {

        return (
            <main className="CustomHelper__wrapper">
                <aside className="CustomHelper__sidebar">
                    <img
                        alt="HEA Team Member"
                        className="CustomHelper__sidebar_img"
                        src={Employee}
                    />
                    <span
                        className="CustomHelper__sidebar_step">Hi! We're Casey & Meygan and we're going to show you around.</span>
                </aside>
                <div className="CustomHelper__content">
                    <div className="mobile__member_container">
                        <img
                            alt="HEA Team Member"
                            className="CustomHelper__sidebar_img"
                            src={Employee}
                        />
                        <span
                            className="CustomHelper__content_name">Hi! I'm Vanessa and I'm going to show you around.</span>
                    </div>

                    <div className="CustomHelper__content_content">
                        {content}
                    </div>


                    <Controls
                        data-tour-elem="controls"
                        className="CustomHelper__controls"
                    >
                        {/*<Arrow*/}
                        {/*    onClick={() => {*/}
                        {/*        gotoStep(current - 1);*/}
                        {/*        decrease_step(current)*/}
                        {/*    }}*/}
                        {/*    disabled={current === 0}*/}
                        {/*    className="CustomHelper__navArrow"*/}
                        {/*/>*/}

                        {/*<Arrow*/}
                        {/*    onClick={*/}
                        {/*        () => {*/}
                        {/*            gotoStep(current + 1);*/}
                        {/*            increase_step(current)*/}
                        {/*        }*/}
                        {/*    }*/}
                        {/*    disabled={current === totalSteps - 1}*/}
                        {/*    className="CustomHelper__navArrow"*/}
                        {/*    inverted*/}
                        {/*/>*/}
                        <div className="navigation__container">
                            <Navigation data-tour-elem="navigation">
                                {Array.from(Array(totalSteps).keys()).map((li, i) => (
                                    <Dot
                                        key={li}
                                        // onClick={() => current !== i && gotoStep(i)}
                                        current={current}
                                        index={i}
                                        disabled={current === i}
                                        showNumber={false}
                                        data-tour-elem="dot"
                                    />
                                ))}
                            </Navigation>
                            <button
                                disabled={current === totalSteps - 1}
                                className="next__button"
                                onClick={() => {
                                    gotoStep(current + 1);
                                    increase_step(current)
                                }
                                }
                            >
                                Next
                            </button>
                        </div>

                    </Controls>

                </div>
            </main>
        )
    }

    return (
        <Tour
            steps={steps}
            isOpen={state.isOpen}
            startAt={state.currentStep}
            onRequestClose={closeTour}
            update={pathname}
            maskClassName="mask"
            className="helper"
            maskSpace={20}
            rounded={5}
            showNumber={false}
            inViewThreshold={0}
            accentColor="#5cb7b7"
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            closeWithMask={false}
            CustomHelper={MyCustomHelper}
        />
    );
}


export default withRouter(CTour);

